import React from "react";
import { HelpIcon, HelpIconProps, HelpIconMode } from "@countysuite/ui";

export type Props = HelpIconProps & {
  style?: any;
};

export const HelpIconButton: React.FC<Props> = (props) => {
  const _style = props.style || {};
  return (
    <span style={{ fontSize: "1.65em", verticalAlign: "middle", ..._style }}>
      <HelpIcon mode={props.mode || HelpIconMode.Modal}>
        {props.children}
      </HelpIcon>
    </span>
  );
};
